/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import globalText from "../../../utils/globalText";
import SmallPopupWithBulletPoints from "../CommonSmallPopupWithBulletPoint";

const MAX_LENGTH = 150;

const RecreatePromptModalPopup = ({
  onConfirmBtnClick,
  onCancelBtnClick,
  customDeclineReason,
  loadingBox,
  inputDisabled,
}) => {
  const [declineRecreateReason, setRecreateDeclineReason] = useState(
    customDeclineReason ?? "Recreate this transaction.",
  );

  const handleInputChange = (event) => {
    let value = event.target.value;

    value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    value = value.replace(/\s+/g, " ");
    value = value.replace(/^\s/, "");
    value = value.slice(0, MAX_LENGTH);

    setRecreateDeclineReason(value);
  };

  const isValidReason = declineRecreateReason.replace(/\s+/g, "").length >= 10;

  const handleClick = () => {
    if (!isValidReason) return;
    onConfirmBtnClick(declineRecreateReason);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && isValidReason && !inputDisabled) {
        handleClick();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [declineRecreateReason, inputDisabled]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-z-index-loader">
      <SmallPopupWithBulletPoints
        headerTitle={globalText?.SEND_FOR_RECREATION}
        subtext={globalText?.PROVIDE_THE_REASON_FOR_RECREATION}
        bulletPoints={[
          globalText?.TRANSACTION_RECREATE_REQUIRED,
          globalText?.TRANSACTION_REJECTION_REQUIRED_FOR_RECREATE,
        ]}
        noteText={globalText?.REJECT_POPUP_ACCOUNT_NOTE_TEXT}
        isTextInputField={true}
        inputPlaceholder={globalText?.REASON}
        inputVariant={computeVariant(declineRecreateReason, isFocused)}
        inputOnFocus={(e) => setIsFocused(true)}
        inputOnBlur={(e) => setIsFocused(false)}
        inputAdornment=""
        inputValue={declineRecreateReason}
        inputOnInput={handleInputChange}
        inputIsDisabled={inputDisabled}
        inputFgColor="var(--text-primary)"
        inputIsFullWidth={true}
        btnOneText={globalText?.CANCEL}
        btnOneHandleFunction={onCancelBtnClick}
        btnOneEnabledBgColor="transparent"
        btnOneOutLineColor="var(--text-primary)"
        btnOneIsDisabled={false}
        btnOneEnabledTextColor="var(--text-primary)"
        btnTwoText={globalText?.REJECT}
        btnTwoHandleFunction={handleClick}
        btnTwoInActiveVariantNeeded={true}
        btnTwoIsDisabled={!isValidReason}
        btnTwoEnabledBgColor={
          !isValidReason ? "var(--text-disabled)" : "var(--failed)"
        }
        btnTwoEnabledTextColor="var(--text-primary)"
        btnTwoIsLoaderNeeded={loadingBox}
        inputBgColor="var(--primary-bg)"
        subtextwithbullet="Y"
      />
    </div>
  );
};

export default RecreatePromptModalPopup;
